<template>
    <div class="idle-resource-warehouse-pane">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :currentPage="page.pageNo"
            searchId="idleResourceWarehouseSearchId"
            :pageID="config.table.pageId"
            @selectChange="selectChange"
            @on-reset="handleReset"
            @btnClick="handleBtnClick"
            @edit-btn="handleEdit"
            @match-btn="handleMatch"
            @result-btn="handleResult"
            @sensitiveClick="handleSensitiveClick"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="provinceCodeSlot">
                <el-select v-model="slotSearchObj.provinceCode" placeholder="仓库省份" clearable @change="handleProvinceChange">
                    <el-option
                        v-for="option in provinceOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </div>
            <div slot="provinceCodeAdvanceSlot">
                <el-select class="region-select" v-model="slotSearchObj.provinceCode" placeholder="仓库省份" clearable @change="handleProvinceChange">
                    <el-option
                        v-for="option in provinceOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </div>
            <div slot="cityCodeListSlot">
                <el-select v-model="slotSearchObj.cityCodeList" placeholder="仓库城市" clearable multiple collapse-tags @change="handleCityChange">
                    <el-option
                        v-for="option in cityOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                        multiple
                    ></el-option>
                </el-select>
            </div>
            <div slot="cityCodeListAdvanceSlot">
                <el-select class="region-select" v-model="slotSearchObj.cityCodeList" placeholder="仓库城市" clearable multiple collapse-tags @change="handleCityChange">
                    <el-option
                        v-for="option in cityOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                        multiple
                    ></el-option>
                </el-select>
            </div>
            <div slot="bottomPriceGreaterThanSlot">
                <el-input v-model.trim="slotSearchObj.bottomPriceGreaterThan" placeholder="最低价">
                    <template slot="prepend">大于等于</template>
                    <template slot="append">元</template>
                </el-input>
            </div>
            <div slot="maximumPriceGreaterThanSlot">
                <el-input v-model.trim="slotSearchObj.maximumPriceGreaterThan" placeholder="最高价">
                    <template slot="prepend">大于等于</template>
                    <template slot="append">元</template>
                </el-input>
            </div>
            <div slot="bottomPriceLessThanAdvanceSlot">
                <el-input v-model.trim="slotSearchObj.bottomPriceLessThan">
                    <template slot="prepend">小于等于</template>
                    <template slot="append">元</template>
                </el-input>
            </div>
            <div slot="bottomPriceGreaterThanAdvanceSlot">
                <el-input v-model.trim="slotSearchObj.bottomPriceGreaterThan">
                    <template slot="prepend">大于等于</template>
                    <template slot="append">元</template>
                </el-input>
            </div>
            <div slot="maximumPriceLessThanAdvanceSlot">
                <el-input v-model.trim="slotSearchObj.maximumPriceLessThan">
                    <template slot="prepend">小于等于</template>
                    <template slot="append">元</template>
                </el-input>
            </div>
            <div slot="maximumPriceGreaterThanAdvanceSlot">
                <el-input v-model.trim="slotSearchObj.maximumPriceGreaterThan">
                    <template slot="prepend">大于等于</template>
                    <template slot="append">元</template>
                </el-input>
            </div>
            <div slot="table-module-btn" v-if="!!supplier">
                <el-tooltip effect="dark" content="新增" placement="bottom">
                    <el-button class="bigData-btn-add" icon="el-icon-plus" type="primary" size="mini" @click="handleAdd"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导入" placement="bottom">
                    <el-button class="bigData-btn-upload" icon="el-icon-upload2" size="mini" @click="handleImport"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button class="bigData-btn-export" icon="el-icon-download" size="mini" :loading="exportLoading" @click="handleExport"></el-button>
                </el-tooltip>
            </div>
            <div slot="table-module-btn" v-else>
                <el-tooltip v-has="'/idleResource-10'" effect="dark" content="新增" placement="bottom">
                    <el-button class="bigData-btn-add" icon="el-icon-plus" type="primary" size="mini" @click="handleAdd"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导入" placement="bottom">
                    <el-button class="bigData-btn-upload" icon="el-icon-upload2" size="mini" @click="handleImport"></el-button>
                </el-tooltip>
                <el-tooltip v-has="'/idleResource-30'" effect="dark" content="导出" placement="bottom">
                    <el-button class="bigData-btn-export" icon="el-icon-download" size="mini" :loading="exportLoading" @click="handleExport"></el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn" v-if="!!supplier">
                <el-button class="bigData-btn-match" type="primary" :loading="matchLoading" @click="handleMatch()">点击匹配</el-button>
                <el-button class="bigData-btn-del" type="primary" :loading="delLoading" @click="handleDel">删除</el-button>
            </div>
            <div slot="page-module-btn" v-else>
                <el-button v-has="'/idleResource-50'" class="bigData-btn-match" type="primary" :loading="matchLoading" @click="handleMatch()">点击匹配</el-button>
                <el-button v-has="'/idleResource-40'" class="bigData-btn-del" type="primary" :loading="delLoading" @click="handleDel">删除</el-button>
            </div>
        </m-pane>
        <WarehouseOperateDialog
            ref="odRef"
            :provinceOptions="provinceOptions"
            @preview="handlePreview"
            @refresh="getTableData"
        />
        <MatchDialog
            ref="mdRef"
            :config="matchConfig"
            :provinceOptions="provinceOptions"
            :businessType="businessType"
            :dict="dict"
            provinceholder="意向省份"
            cityholder="意向城市"
        />
        <ImportDialog
            ref="importRef"
            :tempName="tempName"
            :tempParams="tempParams"
            :tempApi="downloadTemplate"
            :importApi="importWarehouseIdle"
            @reload="getTableData"
        />
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs'
import bigDataLog from '@/utils/bigDataLog'
import mPane from '@/components/supplierPanel';
import WarehouseOperateDialog from './WarehouseOperateDialog.vue';
import MatchDialog from './MatchDialog.vue';
import ImportDialog from './ImportDialog.vue';
import Preview from '../../../components/viewAttachment.vue';
import config from './config.js';
import matchConfig from './matchConfig.js';
import { dictWithUrl } from '@/components/lots/api';
import { searchWarehouseIdleResources, exportResources, deleteWarehouseIdleResources, matchWarehouseIdleResources, downloadTemplate, importWarehouseIdle } from '../../../api/storageSupManage/idleResource.js';
import { getProvinces, getCitys } from '../../../utils/getArea.js'
import { getSensitiveVal } from '../../../utils/common.js'

const INIT_SEARCH_OBJ = {
    createStartTime: dayjs().subtract(180, 'd').format('YYYY-MM-DD 00:00:00'),
    createEndTime: dayjs().format('YYYY-MM-DD 23:59:59'),
}

export default {
    components: { mPane, Preview, WarehouseOperateDialog, MatchDialog, ImportDialog },
    data() {
        return {
            loading: false,
            exportLoading: false,
            matchLoading: false,
            delLoading: false,
            isSensitive: true,
            dict: {},
            totalData: [],
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            searchObj: JSON.parse(JSON.stringify(INIT_SEARCH_OBJ)),
            slotSearchObj: {
                provinceCode: '',
                cityCodeList: [],
                bottomPriceLessThan: '',
                bottomPriceGreaterThan: '',
                maximumPriceLessThan: '',
                maximumPriceGreaterThan: '',
            },
            provinceOptions: [],
            cityOptions: [],
            selected: [],
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            businessType: '3', // 1=装卸闲置资源 2=装卸需求资源 3=仓库闲置资源 4=仓库需求资源
            tempName: '仓库发布资源导入.xlsx',
            tempParams: { fileName: 'supplierWarehouseIdleResources.xlsx' },
            downloadTemplate,
            importWarehouseIdle,
        };
    },
    computed: {
        ...mapState(['supplier']),
        config() {
            const configTemp = { ...config }
            configTemp.searchList = configTemp.warehouseSearchList
            configTemp.table = configTemp.warehouseTable
            if (!!this.supplier) {
                configTemp.table.action.forEach(item => {
                    delete item.ifHas
                })
            }
            return configTemp
        },
        matchConfig() {
            const configTemp = JSON.parse(JSON.stringify(matchConfig))
            configTemp.searchList = configTemp.warehouseSearchList
            configTemp.table = configTemp.warehouseTable
            return configTemp
        },
    },
    methods: {
        selectChange(data) {
            this.selected = data;
        },
        getTableData() {
            if (!this.validate()) {
                return false
            }
            this.loading = true
            searchWarehouseIdleResources(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list.map(item => {
                        item.warehouseType_ = item.warehouseType ?
                            item.warehouseType.split(',').map(item => this.dict.SYS_SU_WH_TYPE[item]).join(',') : ''
                        item.contactNumber_ = (this.isSensitive && item.contactNumber) ?
                            getSensitiveVal(item.contactNumber, 'phone') : item.contactNumber
                        // 是否可租 为 不可租 '0'
                        if (item.rentableFlag === '0') {
                            item.hiddenEvent = ['match', 'result']
                        }
                        return item
                    })
                }
            }).finally(() => { this.loading = false });
        },
        getParams() {
            const params = JSON.parse(JSON.stringify({ ...this.searchObj, ...this.slotSearchObj }));
            params.businessType = this.businessType
            params.pageNo = this.page.pageNo
            params.pageSize = this.page.pageSize
            if (params.warehouseTypeList === '') {
                params.warehouseTypeList = []
            }
            if (params.warehouseFireProtectionLevelList === '') {
                params.warehouseFireProtectionLevelList = []
            }
            if (params.provinceCode) {
                params.provinceCodeList = [params.provinceCode]
            } else {
                params.provinceCodeList = []
            }
            if (params.createTimeArr && params.createTimeArr.length) {
                params.startTime = dayjs(params.createTimeArr[0]).format('YYYY-MM-DD HH:mm:ss')
                params.endTime = dayjs(params.createTimeArr[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            delete params.provinceCode
            delete params.createTimeArr
            return params
        },
        searchChange(data) { // 点击查询
            this.page.pageNo = 1;
            this.searchObj = data;
            this.getTableData();
        },
        pageChange(pageNo) { // 切换分页页数
            this.isSensitive = true
            const phoneCol = config.warehouseTable.columns.findIndex(v => v.prop === 'contactNumber_')
            config.warehouseTable.columns[phoneCol].sensitiveValue = true
            this.page.pageNo = pageNo;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.isSensitive = true
            const phoneCol = config.warehouseTable.columns.findIndex(v => v.prop === 'contactNumber_')
            config.warehouseTable.columns[phoneCol].sensitiveValue = true
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleReset() {
            this.slotSearchObj = {
                provinceCode: '',
                cityCodeList: [],
                bottomPriceLessThan: '',
                bottomPriceGreaterThan: '',
                maximumPriceLessThan: '',
                maximumPriceGreaterThan: '',
            }
        },
        handleBtnClick(val, index, row, prop, buttonName) {
            if (prop === 'warehousePictureUrl') {
                if (!val) {
                    return this.$message.warning('暂无图片!')
                }
                this.handlePreview(val)
            }
        },
        handlePreview(url) {
            this.attachmentShow = true;
            this.rowData = { downUrl: url };
        },
        handleImport() {
            this.$refs.importRef && this.$refs.importRef.open()
        },
        handleExport() {
            if (!this.validate()) {
                return false
            }
            const params = this.getParams()
            delete params.pageNo
            delete params.pageSize
            this.exportLoading = true
            exportResources(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data || '正在导出，请留意右上角文件中心下载文件！');
                }
            }).finally(() => { this.exportLoading = false });
        },
        handleAdd() {
            this.$refs.odRef.open()
        },
        handleEdit(row) {
            this.$refs.odRef.open(row)
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,资源匹配,闲置资源,编辑'); } catch (e) { }
        },
        handleMatch(row) {
            if (!row && !this.selected.length) {
                return this.$message.warning('请选择数据进行匹配!')
            } else if (!row && this.selected.some(item => item.rentableFlag === '0')) {
                // 是否可租 为 不可租 '0'
                return this.$message.warning('只允许点击可租的数据进行匹配!')
            }
            const ids = row ? [row.id] : this.selected.map(item => item.id)
            this.matchLoading = true
            matchWarehouseIdleResources(ids).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('点击匹配成功!')
                    this.getTableData()
                }
            }).finally(() => { this.matchLoading = false })
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,资源匹配,闲置资源,点击匹配'); } catch (e) { }
        },
        handleResult(row) {
            this.$refs.mdRef.open(row)
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,资源匹配,闲置资源,查看匹配结果'); } catch (e) { }
        },
        handleDel() {
            if (!this.selected.length) {
                return this.$message.warning('请选择数据进行删除!')
            }
            this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const ids = this.selected.map(item => item.id)
                this.delLoading = true
                deleteWarehouseIdleResources(ids).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功!')
                        this.getTableData()
                    }
                }).finally(() => { this.delLoading = false })
            }).catch(() => { });
        },
        handleProvinceChange(val) {
            this.slotSearchObj.cityCodeList = []
            this.setCityOptions(val)
        },
        handleCityChange(val) {
            // this.searchObj.cityCode = val
        },
        setProvinceOptions() {
            getProvinces('100000').then(res => {
                this.provinceOptions = res;
            });
        },
        setCityOptions(provinceCode) {
            getCitys(provinceCode).then(res => {
                this.cityOptions = res;
            });
        },
        validate() {
            let valid = true;
            ['bottomPriceLessThan', 'bottomPriceGreaterThan', 'maximumPriceLessThan', 'maximumPriceGreaterThan'].some(key => {
                if ((!['', null, undefined].includes(this.slotSearchObj[key]) && !/^\d{1,6}(\.\d)?$/.test(this.slotSearchObj[key])) || ['0', 0].includes(this.slotSearchObj[key])) {
                    valid = false
                }
            })
            if (!valid) {
                this.$message.warning('最低价和最高价支持6位整数和1位小数，不支持0和负数!')
            }
            return valid
        },
        // 脱敏处理
        handleSensitiveClick(prop, val) {
            this.isSensitive = !this.isSensitive
            this.totalData.forEach(item => {
                item.contactNumber_ = (this.isSensitive && item.contactNumber) ?
                    getSensitiveVal(item.contactNumber, 'phone') : item.contactNumber
            })
        }
    },
    mounted() {
        this.setProvinceOptions()
        dictWithUrl('SYS_SU_WH_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
                this.getTableData();
            }
        })
    },
    beforeDestroy() {
        // 脱敏重置
        this.isSensitive = true
        config.warehouseTable.columns.forEach(col => {
            if (col.sensitive) {
                col.sensitiveValue = true
            }
        })
    }
};
</script>
<style lang="less" scoped>
.idle-resource-warehouse-pane {
    /deep/ .el-input-group__append, /deep/ .el-input-group__prepend {
        padding: 0 8px;
    }
}

.region-select {
    width: 100%;
}
</style>
